﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("post-results")) {
        const postFilters = document.querySelector<HTMLElement>(
            ".post-results__filters-container"
        );

        if (!postFilters) return;

        upOrDownOnScrollWheel(postFilters);
    }
    if (body.classList.contains("job-results")) {
        const jobFilters = document.querySelector<HTMLElement>(
            ".job-results__filters-container"
        );

        if (!jobFilters) return;


        upOrDownOnScrollWheel(jobFilters);
    }
}

export const jobFiltersLocationClickHandler = () => {
    const filter = document.querySelector<HTMLDivElement>('.job-results .location-filter')
    if (!filter) return

    const filterHeader = filter.querySelector<HTMLHeadingElement>('.header')
    if (!filterHeader) return

    filterHeader.addEventListener('click', () => {
        filter.classList.toggle('category-opened')
    })
}